// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledLink from '../../../product/shared/components/labeled-link';
import LabeledString from '../../../shared/components/labeled-string';
import PipDetails from '@deere/cps-it.warranty-model-factory/lib/pip-details';
import PipRequiredItems from './pip-required-items';
import {buildDate} from '../../../shared/services/build-date';

const PipDetailedInformation = props => (
    <div className='pip-detailed-information'>
        <LabeledString
            className='pip-number'
            data={props.pipDetails.pipNumber}
            label='PROGRAM_NUMBER'
        />
        <LabeledString
            className='pip-type'
            data={props.pipDetails.pipType.value}
            label='PIP_TYPE'
        />
        <LabeledLink
            className='dtac-solution'
            data={props.pipDetails.dtac}
            href={props.pipDetails.dtacUrl}
            label='DTAC_SOLUTION'
            rel='noopener noreferrer'
            target='_blank'
        />
        <LabeledString
            className='pip-status'
            data={props.pipDetails.pipStatus.value}
            label='PIP_STATUS'
        />
        <LabeledString
            className='expiry-date'
            data={buildDate(props.pipDetails.expireDate)}
            label='EXPIRES'
        />
        <LabeledString
            className='terminates'
            data={buildDate(props.pipDetails.terminationDate)}
            label='TERMINATES'
        />
        <LabeledString
            className='metric'
            data={props.pipDetails.metric.value}
            label='METRIC'
        />
        <PipRequiredItems requiredItems={props.pipDetails.requiredItems}/>
        <div className='special-instructions'>
            <h3>
                <FormattedMessage id='SPECIAL_INSTRUCTIONS'/>
            </h3>
            <div className='special-instructions-message'>
                {props.pipDetails.specialInstructions ?
                    props.pipDetails.specialInstructions :
                    <FormattedMessage id='NO_SPECIAL_INSTRUCTIONS'/>
                }
            </div>
        </div>
    </div>
);

PipDetailedInformation.displayName = 'PipDetailedInformation';
PipDetailedInformation.propTypes = {
    pipDetails: PropTypes.instanceOf(PipDetails).isRequired
};

export default PipDetailedInformation;



// WEBPACK FOOTER //
// ./src/pip/pip-details/components/pip-detailed-information.js